import { motion } from "framer-motion";

const DOCTOR_IMG =
  "https://images.unsplash.com/photo-1666214277657-e60f05c40b04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxkb2N0b3IlMjBhbmFseXppbmclMjBtcmklMjBzY2FufGVufDB8fHx8MTc4OTEwMjUwMnww&ixlib=rb-4.1.0&q=85";

const CHAPTERS = [
  {
    num: "01",
    title: "SEE THE INVISIBLE",
    copy: "Sub-millimeter lesions hide in plain sight. Our convolutional ensembles read every slice at pixel resolution, surfacing anomalies the fatigued human eye misses at hour eleven of a shift.",
  },
  {
    num: "02",
    title: "DIAGNOSE AT MACHINE SPEED",
    copy: "A chest CT holds 600 slices. A radiologist needs 20 minutes. X-Gen needs 9 seconds — triaging critical cases to the top of the worklist before the patient leaves the scanner.",
  },
  {
    num: "03",
    title: "EARN CLINICAL TRUST",
    copy: "No black boxes. Every flag ships with an explainable heatmap, confidence interval and radiologist-in-the-loop review. The machine proposes. The clinician decides.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-ink py-24 md:py-32" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="font-mono text-xs uppercase tracking-[0.3em] text-mute mb-16"
        >
          The Manifesto — Why X-Gen exists
        </motion.p>

        <div className="space-y-0">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 py-14 md:py-20 border-t border-slate-200"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="md:col-span-3">
                <span className="font-display text-6xl md:text-7xl font-black text-stroke">{c.num}</span>
              </div>
              <div className="md:col-span-5">
                <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{c.title}</h2>
              </div>
              <div className="md:col-span-4 flex flex-col justify-between gap-8">
                <p className="text-mute text-base leading-relaxed">{c.copy}</p>
                {i === 1 && (
                  <div className="border border-slate-200 rounded-2xl overflow-hidden">
                    <img
                      src={DOCTOR_IMG}
                      alt="Radiologist reviewing an X-ray with a patient"
                      className="w-full h-48 object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
                    />
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
